import React, { useRef } from "react";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Editor } from "primereact/editor";
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import GAS from "../../../GAS";
import { Route, useHistory } from 'react-router-dom';

import "./styles.css";

const FimConfiguracao = ({ questionario, setQuestionario, setFluxoGerenciamento }) => {

    //hooks react
    const history = useHistory();
    const toast = useRef(null);

    //functions para atribuir valores dos inputs ao modelo questionario
    const saveQuestionario = () => {
        let gasObj = GAS.getInstance();

        let inicioAplicacaoISO = questionario.inicioAplicacao;
        let terminoAplicacaoISO = questionario.terminoAplicacao

        if (questionario.inicioAplicacao instanceof Date) {
            inicioAplicacaoISO = questionario.inicioAplicacao.toISOString();
        }

        if (questionario.terminoAplicacao instanceof Date) {
            terminoAplicacaoISO = questionario.terminoAplicacao.toISOString();
        }

        // Crie um novo objeto questionario com as datas em formato ISO
        const questionarioToSend = {
            ...questionario,
            inicioAplicacao: inicioAplicacaoISO,
            terminoAplicacao: terminoAplicacaoISO,
        };

        gasObj
            .request('MCPAQuestionario.instance.SERVICE.POSTSaveNewQuestionario', questionarioToSend)
            .then((RESPONSE) => {
                if(RESPONSE.response === true) {
                    history.push('/');
                    window.location.reload();
                } else {
                    toast.current.show({ severity: 'error', summary: 'ERRO!', detail: `Não foi possível registrar novo questionário. \n${RESPONSE.message}`, life: 6000 });
                }
            })
            .catch((e) => {
                toast.current.show({ severity: 'error', summary: 'ERRO!', detail: `Não foi possível registrar novo questionário. \n${e.message}`, life: 6000 });
            });
    };

    const setTextoFinalChange = (value) => {
        setQuestionario((prevQuestionario) => ({
            ...prevQuestionario,
            textoFinal: value,
        }));
    };

    const confirmSave = () => {
        confirmDialog({
            message: 'Você quer salvar esse questionario? Se atente que questionários com informações em branco não estarão livres para resposta',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            accept: saveQuestionario,
            acceptLabel: 'Sim',
            rejectLabel: 'Não'
        });
    };


    //renderização dos componentes da pagina
    return (
        <div className="questionario-etapa-prepos" style={{marginTop: '0px'}}>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Card title="Termino do Questionário">
                <p className="m-0">
                    <div className="dados-finais">
                        <div className="textoFinal">
                        <label className="atributo">Texto Final</label>
                            <Editor
                                id="input-area"
                                onTextChange={(e) => setTextoFinalChange(e.htmlValue)}
                                className="editor-final"
                                onLoad={(quill) => {
                                    if (questionario.textoFinal) {
                                        quill.clipboard.dangerouslyPasteHTML(0, questionario.textoFinal, 'silent');
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <Route render={(props) => (
                        <div className="botoes">
                            <Button className='p-button-danger' label='RETROCEDER' icon='pi pi-arrow-left' onClick={() => {
                                setFluxoGerenciamento('ConfigQ')
                            }} />
                            <Button className='p-button-success' label='AVANÇAR' icon='pi pi-arrow-right' iconPos="right" style={{background: "#4caf50", width: "1.8in"}} onClick={confirmSave} />
                        </div>
                    )} />
                </p>
            </Card>
        </div>
    )
};

export default FimConfiguracao;
